import {Link} from "@/i18n/routing";
import Image from 'next/image';
import {spaceAndRoundNumber} from '@/libs/number.util';
import {useEffect, useState} from 'react';
import {ClientTypes, ProductStatus, ProductTag} from '@/libs/constants/common.constants';
import {useTranslations} from 'next-intl';
import ProductPrice from '@/components/shared/cards/ProductPrice';

export default function CartProductItem({ product, quantity, onDeleteProduct, type, clientType, onManipulateQuantity, submitting }) {
  const t = useTranslations('catalog');
  const [newQuantity, setNewQuantity] = useState(quantity);
  
  const currentPrice = clientType === ClientTypes.WHOLESALER && product.price.wholesalePrice != null ? product.price.wholesalePrice : product.price.priceComputed;
  
  useEffect(() => {
    setNewQuantity(quantity);
  }, [quantity]);
  
  const onQuantityChange = (e) => {
    setNewQuantity(prevState => {
      const currentQuantity = !parseInt(e.target.value) ? 1 : parseInt(e.target.value);
      
      onManipulateQuantity({
        product,
        quantity: currentQuantity,
        price: prevState * currentPrice - currentQuantity * currentPrice
      });
      return currentQuantity;
    });
    
  }
  
  const onMinusQuantityClick = () => {
    if (submitting) return;

    setNewQuantity(prevState => {
      const currentQuantity = prevState <= 1 ? prevState : prevState - 1;
      
      if (prevState - 1 > 0) {
        onManipulateQuantity({
          product,
          quantity: currentQuantity,
          price: currentPrice
        });
      }
      return currentQuantity;
    });
  }
  
  const onPlusQuantityClick = () => {
    if (submitting) return;
    
    setNewQuantity(prevState => {
      const currentQuantity = prevState + 1;
      
      onManipulateQuantity({
        product,
        quantity: currentQuantity,
        price: -currentPrice
      });
      return currentQuantity;
    });
  }
  
  return (
      <>
        <div className="mini-cart-img">
          <Link href={`/products/${product.alt}`}>
            <Image
                key={product.alt}
                src={product.coverImage}
                alt={product.title}
                placeholder="blur"
                blurDataURL={product.coverImage}
                width={1000}
                height={1000}
                style={{height: 'auto', aspectRatio: 1, objectFit: 'cover'}}
            />
          </Link>
          <span
              onClick={() => onDeleteProduct(product, currentPrice * newQuantity)}
              className="mini-cart-item-delete"
          >
            <i className="icon-cancel"></i>
          </span>
        </div>
        <div className="mini-cart-info">
          <h6>
            <Link href={`/products/${product.alt}`}>
              {" "}
              {product.title}
            </Link>
          </h6>
          {/*<p>{product.descriptionShort}</p>*/}
          <p className="cart-status">
            {
              !!product.status ? (
                  <>
                    <strong className="me-1">{t('availability')}:</strong>
                    <span>
                      {t(`productStatuses.${product.status}`)}
                      {
                        product.quantity > 0 && product.status === ProductStatus.IN_STOCK ? (
                            ` (${product.quantity}${t('pc')})`
                        ) : ''
                      }
                    </span>
                  </>
              ) : ''
            }
          </p>
          {
            type === 'cart' ? (
                <>
                  <span className="mini-cart-quantity">
                    {newQuantity} x
                    {' '}
                    {product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                    <span>{spaceAndRoundNumber(currentPrice)}</span>
                    {!product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                    {' = '}
                    {product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                    <span>{spaceAndRoundNumber(newQuantity * currentPrice)}</span>
                    {!product.price.currencyObj.left ? (<span className="currency-sign-font">{product.price.currencyObj.symbol}</span>) : ''}
                    {
                      clientType === ClientTypes.WHOLESALER && product.price.wholesalePrice != null ? (
                          <span className="wholesale-word secondary-color">{' ' + t('wholesale')}</span>
                      ) : product.discount > 0 && product.tag === ProductTag.SALE ? (
                          <span className="wholesale-word secondary-color">{' '}({`-${product.discount * 100}%`})</span>
                      ) : ''
                    }
                  </span>
                  <div className="ltn__product-details-menu-2">
                    <ul>
                      <li>
                        <div className="cart-plus-minus">
                          <div
                              className="dec qtybutton"
                              onClick={onMinusQuantityClick}
                          >-</div>
                          <input
                              onChange={onQuantityChange}
                              type="text"
                              value={newQuantity}
                              // disabled={submitting}
                              // name="qtybutton"
                              className="cart-plus-minus-box"
                          />
                          <div
                              className="inc qtybutton"
                              onClick={onPlusQuantityClick}
                          >+</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </>
            ) : (
                <ProductPrice
                    price={product.price}
                    clientType={clientType}
                />
            )
          }
        </div>
      </>
  );
};
